export default "__VITE_ASSET__fabc7f39__"